import React, {useMemo, useState} from "react";
import {FaTableCellsLarge} from "react-icons/fa6";
import Button from "../../../components/button";
import Card from "../../../components/card";
import InputForm from "../../../components/input-form";
import SelectComponent from "../../../components/select-component";
import BoardLibraryItem from "./board-library-item";
import {FaEraser, FaPlusSquare} from "react-icons/fa";

const sortOptions = [
    {value: "recent", label: "Mais recentes"},
    {value: "name-asc", label: "Nome (A–Z)"},
    {value: "name-desc", label: "Nome (Z–A)"},
];
const visibilityOptions = [
    {value: "all", label: "Todas as visibilidades"},
    {value: "private", label: "Privados"},
    {value: "shared", label: "Compartilhados"},
];

const BoardsLibrary = ({boards, onCreate, onOpen, onEdit, onCopy, onDelete}) => {
    const [search, setSearch] = useState("");
    const [sort, setSort] = useState(sortOptions[0]);
    const [visibility, setVisibility] = useState(visibilityOptions[0]);

    const filteredBoards = useMemo(() => {
        const normalizedSearch = search.trim().toLocaleLowerCase("pt-BR");
        const result = boards.filter(board => (!normalizedSearch || board.name.toLocaleLowerCase("pt-BR").includes(normalizedSearch)) && (visibility.value === "all" || board.visibility === visibility.value));
        return result.sort((a, b) => {
            if (sort.value === "name-asc") return a.name.localeCompare(b.name, "pt-BR");
            if (sort.value === "name-desc") return b.name.localeCompare(a.name, "pt-BR");
            return new Date(b.createdAt) - new Date(a.createdAt);
        });
    }, [boards, search, sort, visibility]);

    const clearFilters = () => {
        setSearch("");
        setSort(sortOptions[0]);
        setVisibility(visibilityOptions[0]);
    };

    return (
        <div className="flex h-full min-h-[560px] flex-col gap-3">
            <Card wrapperClass="!border !border-slate-200 !shadow-sm" bodyClass="!p-3">
                <div className="grid gap-4 lg:grid-cols-12">
                    <div className={"flex col-span-5 gap-4"}>
                        <Button type="button" onClick={onCreate} col="w-[250px]"><FaPlusSquare /> Adicionar quadro</Button>
                        <InputForm id="boards-search" type="search" label="Buscar por nome do quadro" value={search} onChange={({target}) => setSearch(target.value)} col="w-full" />
                    </div>
                    <SelectComponent instanceId="boards-sort" label="Ordenar" options={sortOptions} value={sort} onChange={setSort} col="lg:col-span-3" isClearable={false} />
                    <div className="flex gap-4 col-span-4">
                        <SelectComponent instanceId="boards-visibility" label="Visibilidade" options={visibilityOptions} value={visibility} onChange={setVisibility} col="w-full" isClearable={false} />
                        <Button type="button" title="Limpar filtros" onClick={clearFilters} col="w-[60px]"><FaEraser /></Button>
                    </div>
                </div>
            </Card>

            <Card title="Meus quadros" wrapperClass="min-h-0 flex-1 !border !border-slate-200 !shadow-sm" bodyClass="h-full overflow-y-auto !p-5">
                {filteredBoards.length > 0 ? (
                    <div className={"grid gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4"}>
                        {filteredBoards.map(board => <BoardLibraryItem key={board.id} board={board} onOpen={() => onOpen(board.id)} onEdit={() => onEdit(board)} onCopy={() => onCopy(board.id)} onDelete={() => onDelete(board.id)} />)}
                    </div>
                ) : (
                    <div className="flex h-64 flex-col items-center justify-center text-center">
                        <FaTableCellsLarge className="mb-3 text-4xl text-slate-300" />
                        <p className="font-semibold text-slate-500">Nenhum quadro encontrado</p>
                        <p className="mt-1 text-xs text-slate-400">Crie um quadro ou altere os filtros da pesquisa.</p>
                    </div>
                )}
            </Card>
        </div>
    );
};

export default BoardsLibrary;
